<template>
  <div v-if="items && items.length > 0" class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>{{'invoice_nr' | translate}}</th>
        <th>{{'invoice_date' | translate}}</th>
        <th>{{'invoice_from_to' | translate}}</th>
        <th>{{'bills' | translate}}</th>
        <th>{{'itemized_bill' | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items">
        <td>{{item.invoice_number}}</td>
        <td>{{item.invoice_date}}</td>
        <td>{{item.date_range_from}} - {{item.date_range_to}}</td>
        <td>
          <a class="btn btn-success btn-sm" :href="item.invoice_path" target="_blank">
            <i class="fa fa-cloud-download mr-5"></i>{{'pdf_download' | translate}}
          </a>
        </td>
        <td>
          <a :href="item.itemized_path" target="_blank" class="btn btn-success btn-sm">
            <i class="fa fa-cloud-download mr-5"></i>{{'csv_download' | translate}}
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <div class="callout callout-info">
      <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{'info' | translate}}</h4>
      <p>{{'no_invoices' | translate}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
    model () {
      this.items = []
    },
    language () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Tables/InvoicesTable.vue